/**
 * app.config.js — Proje konfigürasyonu
 * ─────────────────────────────────────
 * YENİ PROJEDE YAPILACAKLAR:
 *   1. APP_NAME, LANGUAGES → güncelle
 *   2. NAV_ITEMS, MOBILE_NAV_ITEMS, BOTTOM_NAV_ITEMS → yeni projenin menüleri
 *   3. FEATURE_ROUTES → yeni ekranları ekle, eskilerini sil
 *   4. FEATURE_REDUCERS → feature slice'ları varsa buraya ekle
 *   5. RIGHT_PANEL → null yap (yeni projede sağ panel yoksa)
 *
 * Layout, ProtectedRoute ve store/index.js bu dosyayı okur.
 * Hiçbir infrastructure dosyası features/ klasörünü doğrudan import ETMEZ.
 */

import React from "react";

// ─── Uygulama Adı ─────────────────────────────────────────────────────────────
export const APP_NAME = "Daiking Mobile";

// ─── Desteklenen Diller ───────────────────────────────────────────────────────
export const LANGUAGES = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "ar", label: "AR" },
  { code: "ja", label: "JA" },
];

// ─── Sidebar Menü Öğeleri ─────────────────────────────────────────────────────
// Sadece statik menüler — ek menüler API'den (drawer-nav) gelir.
export const NAV_ITEMS = [
  { id: "feed", path: "/", icon: "fas fa-home", labelKey: "nav.home" },
];

// Sadece mobilde görünen menü öğeleri (TopBar'dan erişilebilir ekranlar)
export const MOBILE_NAV_ITEMS = [
  {
    id: "events",
    path: "/events",
    icon: "fas fa-calendar-alt",
    labelKey: "nav.events",
  },
  {
    id: "notifications",
    path: "/notifications",
    icon: "fas fa-bell",
    labelKey: "nav.notifications",
  },
  {
    id: "announcements",
    path: "/announcements",
    icon: "fas fa-bullhorn",
    labelKey: "nav.announcements",
  },
];

// Sidebar alt kısmındaki öğeler (profil vb.)
export const BOTTOM_NAV_ITEMS = [
  {
    id: "profile",
    path: "/profile",
    icon: "fas fa-user",
    labelKey: "nav.profile",
  },
];

// ─── Korumalı Sayfa Route'ları ────────────────────────────────────────────────
// Her feature ekranını buraya ekle. ProtectedRoute bu listeyi okur.
// YENİ PROJEDE: Bu listeyi temizle, kendi ekranlarını ekle.
export const FEATURE_ROUTES = [
  { path: "/", component: React.lazy(() => import("../features/home/Home")) },
  {
    path: "/home",
    component: React.lazy(() => import("../features/home/Home")),
  },
  {
    path: "/first-day",
    component: React.lazy(
      () => import("../features/first-day/screens/FirstDayScreen"),
    ),
  },
  {
    path: "/market",
    component: React.lazy(
      () => import("../features/market/screens/MarketScreen"),
    ),
  },
  {
    path: "/payroll",
    component: React.lazy(
      () => import("../features/payroll/screens/PayrollScreen"),
    ),
  },
  {
    path: "/suggest",
    component: React.lazy(
      () => import("../features/suggestions/screens/SuggestionsScreen"),
    ),
  },
  {
    path: "/profile",
    component: React.lazy(
      () => import("../features/profile/screens/ProfileScreen"),
    ),
  },
  {
    path: "/events",
    component: React.lazy(
      () => import("../features/events/screens/EventsScreen"),
    ),
  },
  {
    path: "/notifications",
    component: React.lazy(
      () => import("../features/notifications/screens/NotificationsScreen"),
    ),
  },
  {
    path: "/announcements",
    component: React.lazy(
      () => import("../features/announcements/screens/AnnouncementsScreen"),
    ),
  },
  {
    path: "/discount-coupons",
    component: React.lazy(
      () =>
        import("../features/discount-coupons/screens/DiscountCouponsScreen"),
    ),
  },
  {
    path: "/polls",
    component: React.lazy(
      () => import("../features/polls/screens/PollsScreen"),
    ),
  },
  {
    path: "/my-groups",
    component: React.lazy(
      () => import("../features/my-groups/screens/MyGroupsScreen"),
    ),
  },
  {
    path: "/posts/:id",
    component: React.lazy(
      () => import("../features/home/screens/PostDetailScreen"),
    ),
  },
  {
    path: "/mydtas",
    component: React.lazy(
      () => import("../features/mydtas/screens/MyDtasScreen"),
    ),
  },
];

// ─── Tam Ekran Route'ları (Layout olmadan render edilir) ──────────────────────
// Bu rotalar sidebar/topbar/rightbar olmadan, tam ekran açılır.
// YENİ PROJEDE: Demo/araç sayfaları varsa buraya ekle.
export const FULLSCREEN_ROUTES = [
  {
    path: "/grid",
    component: React.lazy(
      () => import("../features/grid-demo/screens/GridDemoScreen"),
    ),
  },
];

// ─── Feature Redux Reducer'ları ───────────────────────────────────────────────
// Feature'a özgü Redux slice'ı varsa buraya ekle: { myFeature: myFeatureReducer }
// store/index.js bu objeyi spread eder.
// YENİ PROJEDE: Boş bırak — { }
import { mydtasNotificationReducer } from "../features/mydtas/store/mydtasNotificationSlice";
export const FEATURE_REDUCERS = {
  mydtasNotification: mydtasNotificationReducer,
};

// ─── Sağ Panel Bileşeni ───────────────────────────────────────────────────────
// Layout'un sağ sütununda gösterilecek bileşen.
// YENİ PROJEDE: null yap → sağ panel görünmez.
// Bu projede: Etkinlik / Duyuru / Anket özet widgetı
export { default as RIGHT_PANEL } from "../features/home/components/RightBar/RightBar";
